import { useClass } from "@breezerr";
import { addPropsToChildren } from "@brz-utils/add.props.to.children";
import { useBreakpoint } from "@brz-utils/contexts/is.breakpoint";
import { Button, ButtonProps, Fade, Paper, Popover, PopoverProps, SwipeableDrawer } from "@mui/material";
import React, { ReactNode } from "react";
import { Uppercase } from "./uppercase";


type DropDownButtonProps = {
    label: string;
    children: ReactNode | ReactNode[];
    ButtonProps?: ButtonProps;
    DropDownProps?: {
        align?: 'left' | 'center' | 'right',
        textAlign?: 'left' | 'center' | 'right',
        className?: string;
        disableScrollLock?: boolean;
    };
};

const alignToFlex = {
    left: 'start',
    center: 'center',
    right: 'end'
};

export const DropDownButton = (props: DropDownButtonProps) => {
    const { isMobile } = useBreakpoint();
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    // States
    const [open, setOpen] = React.useState(false);
    

    return (
        <>
            <Button {...props.ButtonProps} ref={anchorRef} onClick={() => {
                setOpen((prev) => !prev);
            }}>
                <span>{props.label}</span>
                <svg className={useClass('ml-0.7rem')} xmlns="http://www.w3.org/2000/svg" width="8.847" height="5.838" viewBox="0 0 8.847 5.838">
                    <path d="M0,0,3.01,3.01,6.019,0" transform="translate(1.414 1.414)" fill="none" stroke="#54687a" strokeLinecap="round" strokeWidth="2" />
                </svg>
            </Button>

            {isMobile ? (
                <SwipeableDrawer
                    disableDiscovery={true}
                    disableSwipeToOpen={true}
                    anchor={'bottom'}
                    open={open}
                    onClose={() => {setOpen(false)}}
                    onOpen={() => null}
                    PaperProps={{
                        className: useClass(`py-1rem radius-top-left-1rem radius-top-right-1rem`)
                    }}
                >
                    <Uppercase className={useClass('px-2rem pt-2rem pb-2rem')}>{ props.label }</Uppercase>
                    {addPropsToChildren(props.children, {
                        className: useClass(`justify-content-start`),
                        onClick: () => {
                            setOpen(false);
                        }
                    })}
                </SwipeableDrawer>
            ) : (
                <Popover
                    open={open}
                    onClose={() => setOpen(false)}
                    PaperProps={{
                        elevation: 3,
                        sx: {
                            padding: '1rem 0',
                            borderRadius: '1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: '15rem'
                        },
                        className: props.DropDownProps?.className
                    }}
                    {...props.DropDownProps}

                    disableAutoFocus
                    // disablePortal
                    // disableScrollLock
                    disableEnforceFocus
                    

                    anchorOrigin={{
                        horizontal: props.DropDownProps?.align || 'center',
                        vertical: 'bottom'
                    }}
                    transformOrigin={{
                        horizontal: props.DropDownProps?.align || 'center',
                        vertical: 'top'
                    }}
                    TransitionComponent={Fade}
                    anchorEl={anchorRef.current}
                    slotProps={{
                        backdrop: {
                            sx: {
                                background: 'transparent'
                            }
                        }
                    }}
                >
                    {addPropsToChildren(props.children, {
                        className: useClass(`justify-content-${alignToFlex[props.DropDownProps?.textAlign || 'left']}`),
                        onClick: () => {
                            setOpen(false);
                        }
                    })}
                </Popover>
            )}
        </>
    );
};